export const environment = {
  production: false,
  api: {
    url: 'https://sso-test.staatsanzeiger.de/api/'
  },
  oidc: {
    url: 'https://sso-test.staatsanzeiger.de/api/oidc/'
  }
};
